
import {Component, Watch} from 'vue-property-decorator';
import {SET_LOCATIONS} from '@/store/mutationTypes';
import {mixins} from 'vue-class-component';
import SnackbarMixin from '@/mixins/SnackbarMixin';
import LoadingMixin from '@/mixins/LoadingMixin';
import DebounceMixin from '@/mixins/DebounceMixin';
import {Biodata, biodataModule} from '@/store/modules/biodata';
import {swalSuccess, swalError} from '@/plugins/swal';

@Component
export default class FormBiodata extends mixins(
  LoadingMixin,
  SnackbarMixin,
  DebounceMixin,
) {
  @biodataModule.State('locations') locations!: Biodata[];
  @biodataModule.Mutation(SET_LOCATIONS) setLocation!: Function;
  @biodataModule.Action('getLocation') getLocation!: Function;

  disableButton = false;
  menu = false;
  form = {
    contact_name: '',
    contact_address: '',
    contact_rt: '',
    contact_rw: '',
    contact_phone: '',
    contact_type: '',
  };
  get rules() {
    return {
      contact_name: 'required',
      contact_address: 'required',
      contact_rt: 'required',
      contact_rw: 'required',
      contact_phone: 'required',
      contact_type: 'required',
    };
  }
  get profile() {
    return JSON.parse(localStorage.getItem('USER') || '{}');
  }
  async mounted() {
    await this.fetchDetail();
  }
  destroyed() {
    this.setLocation([]);
  }
  async fetchDetail() {
    try {
      this.startLoading('detail');
      const {data} = await this.$store.dispatch('biodata/getEmergency');
      this.finishLoading('detail');
      if (data !== null) {
        this.form = data;
      }
    } catch (e) {
      this.catchError(e);
    }
  }

  async onSubmit() {
    try {
      this.startLoading('saving');
      if (
        this.profile.name === this.form.contact_name ||
        this.profile.whatsapp === this.form.contact_phone
      ) {
        swalError.fire({
          title: 'Failed!',
          text:
            'Kontak yang bisa di hubungi atau phone tidak boleh sama dengan data diri anda',
        });
        return;
      }
      const res = await this.$store.dispatch(
        'biodata/updateEmergency',
        this.form,
      );

      if (res.status === 200) {
        swalSuccess.fire({
          title: 'Success!',
          text: res.data.message,
        });
        this.finishLoading('saving');
      }
      this.disableButton = false;
      this.fetchDetail();
      this.$emit('nextStep', 4);
    } catch (e) {
      swalError.fire({
        title: 'Failed!',
        text:
          e.response?.message ||
          'Sebuah kesalahan yang tidak diduga telah terjadi.',
      });
    }
  }
}
